export default class TableEntityBase {
    PartitionKey:string|null = null;
    RowKey:string|null = null;
    ETag: any;
    Timestamp: string|null = null;
}